import { Text } from "@mantine/core"
import { Missing } from "@tfg/ui"

type Props = {
  value?: number
  unit: string
}

export const UnitCell = ({ value, unit }: Props) => {
  if (!value) return <Missing />

  const absValue = Math.abs(value)
  const formattedValue =
    absValue > 1 && absValue < 1000 ? value.toFixed(2) : value.toExponential(2)
  return (
    <Text style={{ whiteSpace: "nowrap" }}>
      {formattedValue} {unit}
    </Text>
  )
}
